<template>
    <base-modal class="congratulation-modal" :controlled="true" :open="true" :unmountAfterMs="200" :closeable="false">
        <div class="congratulation-modal__image mb-4">
            <img src="@assets/images/user-onboarding/completed.png" alt="Completed" />
        </div>
        <div class="text-center text-darkblue">
            <h5 class="font-bold text-xl mb-2">
                Chúc mừng! <br />
                Bạn đã hoàn thành tất cả <br />
                hướng dẫn
            </h5>
            <p class="text-lg font-normal mb-4">
                Giờ bạn đã sẵn sàng để bắt đầu hành trình hành trình kiếm tiền bằng Affiliate Marketing cùng HyperLead!
            </p>
        </div>
        <Button class="w-full" @click="onComplete">Hoàn tất!</Button>
    </base-modal>
</template>

<script>
import onboardingService from '../../../core/services/onboardingService';
import userOnboardingService from '../../../core/services/userOnboardingService';
import Button from '../../Button/Button.vue';
import BaseModal from '../../Modal/BaseModal.vue';

export default {
    name: 'congratulation-modal',

    components: {
        Button,
        BaseModal,
    },

    props: {},

    data() {
        return {};
    },

    methods: {
        onComplete() {
            onboardingService.reset();
            onboardingService.resetOnboarding();
            
            this.$emit('complete');
        },
    },

    mounted() {
        userOnboardingService.completeAll().then(() => {
            onboardingService.reset();
            onboardingService.resetOnboarding();
        });
    },
};
</script>

<style lang="scss">
.congratulation-modal {
    .congratulation-modal__image {
        padding: 16px 16px 0;

        img {
            width: 100%;
            object-fit: cover;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UserOnboarding/components/CongratulationModal.vue